import styled from 'styled-components';

import { colors } from 'styles';

export const Container = styled.aside`
  display: flex;
  flex-direction: column;
  width: 20rem;
  height: 100%;
  gap: 2rem;

  color: var(--primary_color);
  margin-right: 3.6rem;

  .filter-box {
    width: 20rem;
    padding: 1rem;
    padding-right: 0;
    border-radius: 0.8rem;
    background-color: var(--white);

    h3 {
      text-transform: uppercase;
      margin-bottom: 1.2rem;
      font-weight: 800;
    }

    p {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-weight: 700;
      font-size: 1.1rem;
      max-width: 15rem;
    }
  }

  .filter-box.without-tree .filter-box-without-tree-group {
    max-height: 30rem;
    overflow-y: scroll;

    ::-webkit-scrollbar-track {
      background-color: transparent;
    }
    scroll-margin-left: 1rem;
    scrollbar-track-color: transparent;
    ::-webkit-scrollbar {
      width: 0.4rem;
      background: transparent;
    }

    ::-webkit-scrollbar-thumb {
      background: var(--primary_color);
      border-radius: 1rem;
    }

    scrollbar-base-color: var(--primary_color);
  }

  .filter-box.without-tree .filter-box-without-tree-group p {
    padding: 0.2rem 0;
  }

  .filter-box .checkbox.father-group {
    max-height: 30rem;
    overflow-y: scroll;
    padding-right: 0.5rem;

    ::-webkit-scrollbar-track {
      background-color: transparent;
    }
    scroll-margin-left: 1rem;
    scrollbar-track-color: transparent;
    ::-webkit-scrollbar {
      width: 0.4rem;
      background: transparent;
    }

    ::-webkit-scrollbar-thumb {
      background: var(--primary_color);
      border-radius: 1rem;
    }

    scrollbar-base-color: var(--primary_color);
  }

  .filter-box .checkbox.father-group > .checkbox-item {
    padding: 0.6rem;
    margin-top: 0;
  }

  .filter-box .checkbox.father-group > .checkbox-item + .checkbox-item {
    border-top: 0.01rem solid var(--gray_light);
  }

  .swiper .swiper-button-prev,
  .swiper .swiper-button-next {
    display: none;
  }

  @media (max-width: 768px) {
    .filter-box {
      padding: 0;
      width: 100%;
    }
  }

  @media (max-width: 400px) {
    .filter-box h3 {
      font-size: 1rem;
    }

    .filter-box p {
      font-size: 0.9rem;
    }

    .input-checkbox {
      padding-left: 1rem;

      span {
        width: 0.7rem;
        height: 0.7rem;
      }
    }
  }
`;
